const UI_LABELS = {
  "slovak": {
    "HRA": "HRA",
    "VÝBER ZOSTAVY": "VÝBER ZOSTAVY",
    "VÝBER FÁZY TRÉNINGU": "VÝBER FÁZY TRÉNINGU",
    "DRIL": "DRIL",
    "PRESTÁVKA": "PRESTÁVKA"
  },
  "english": {
    "HRA": "PLAY",
    "VÝBER ZOSTAVY": "SELECT LINEUP",
    "VÝBER FÁZY TRÉNINGU": "SELECT TRAINING PHASE",
    "DRIL": "DRILL",
    "PRESTÁVKA": "BREAK"
  }
};

function getLabel(key) {
  const lang = sessionStorage.getItem("userLanguage") || "slovak";
  return UI_LABELS[lang]?.[key] || key;
}

const LANG_MAPPING = {
  "slovak": "sk",
  "english": "en"
};

function getTranslationCode() {
  const lang = sessionStorage.getItem("userLanguage") || "slovak";
  return LANG_MAPPING[lang] || "sk";
}

function localizeEvent(event) {
  if (!event) return event;
  const code = getTranslationCode();
  console.log(code, event.translations, event.translations[code]);
  if (code !== "sk" && event.translations && event.translations[code]) {
    const t = event.translations[code];
    
    if (t.title) event.title = t.title;
    if (t.text) event.text = t.text;
  }
  return event;
}

function applyLanguage() {
  const currentLang = sessionStorage.getItem("userLanguage") || "slovak";
  
  // Handle visibility of elements with lang attribute
  // We exclude the root <html> tag from being hidden
  document.querySelectorAll("[lang]").forEach(el => {
    if (el.tagName === "HTML") return;
    
    const elLang = el.getAttribute("lang");
    // If element has a lang attribute, show it only if it matches currentLang
    el.style.display = (elLang === currentLang) ? "" : "none";
  });

  // Handle placeholders
  document.querySelectorAll("[data-placeholder-" + currentLang + "]").forEach(el => {
    el.placeholder = el.getAttribute("data-placeholder-" + currentLang);
  });

  // Special case: Elements WITHOUT a lang attribute inside a container that has siblings with lang
  // To avoid breaking existing code, we suggest users to always use lang attributes for translations.
}

// Automatically apply on load
if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", applyLanguage);
} else {
  applyLanguage();
}

window.applyLanguage = applyLanguage;
window.getLabel = getLabel;
window.localizeEvent = localizeEvent;
window.getTranslationCode = getTranslationCode;
